import { PresenceStatus } from '../../context/AuthContext';

export type PresenceStatusConfig = {
  value: PresenceStatus;
  label: string;
  colorClass: string;
};

export const PRESENCE_STATUS_CONFIG: Record<PresenceStatus, PresenceStatusConfig> = {
  available: {
    value: 'available',
    label: 'Available',
    colorClass: 'bg-success',
  },
  busy: {
    value: 'busy',
    label: 'Busy',
    colorClass: 'bg-warning',
  },
  offline: {
    value: 'offline',
    label: 'Offline',
    colorClass: 'bg-muted-foreground',
  },
};

export const PRESENCE_STATUS_OPTIONS: PresenceStatusConfig[] = [
  PRESENCE_STATUS_CONFIG.available,
  PRESENCE_STATUS_CONFIG.busy,
  PRESENCE_STATUS_CONFIG.offline,
];








